import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const downloadQrSummeryList = createAsyncThunk( "qrSummeryList/downloadQrSummeryList",
  async (params = {}, { rejectWithValue }) => {
    try {
      const apiParams = {
        servicetype: params.qr_type || undefined,
        date_start: params.date || undefined,
        date_end: params.date || undefined,
        department: params.department || undefined,
        keyword: params.keyword || undefined
      };
      
      const response = await axiosHttp.get('lcqr/downloadlogsummary', { 
        params: apiParams,
        responseType: 'blob'
      });
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Download failed');
    }
  }
);

const qrSummeryDownloadSlice = createSlice({
  name: "qrSummeryDownload",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadQrSummeryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadQrSummeryList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(downloadQrSummeryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default qrSummeryDownloadSlice.reducer;
